import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { StepperService } from "../../../services/stepper.service";
import { constants } from "../../../utils/constants";
import { IErrorAlert } from "src/app/interfaces/error.interface";
import { AccountService } from "../../../services/account.service";
import helpers from "src/app/utils/helpers";
import Swal from "sweetalert2";

@Component({
  selector: "app-enter-code",
  templateUrl: "./enter-code.component.html",
  styleUrls: ["../../auth.styles.css"],
})
export class EnterCodeComponent implements OnInit {
  constants: any = constants;
  helpers: any = helpers;
  operation: string;
  error: IErrorAlert;
  loading: boolean;
  form: FormGroup;

  textInfo: string = "Recuerda que el código tiene una validez de 5 minutos."

  constructor(
    private _fb: FormBuilder,
    private _router: Router,
    private _route: ActivatedRoute,
    public _account: AccountService,
    public _stepper: StepperService
  ) {
    this._route.data.subscribe((data: any) => {
      this._stepper.setCurrent(data.step);
      this.operation = data.operation;
      if (!this._account.getCompanyData().ruc) {
        this.back();
      }
    });
  }

  ngOnInit(): void {
    this.form = this._fb.group({
      code: [
        "",
        [
          Validators.required,
          Validators.pattern(constants.validations.numeric.pattern),
          Validators.minLength(6),
        ],
      ],
    });
    this.helpers.initFormListeners(this.form);
  }

  generateToken() {
    this.error = null;
    this.loading = true;
    this._account
      .generateToken({
        docNumber: this._account.getAdminData().docNumber,
        docType: this._account.getAdminData().docType,
        ruc: this._account.getCompanyData().ruc,
      })
      .subscribe(
        () => {
          this.loading = false
          this.showSuccessAlert();
        },
        (err: IErrorAlert) => {
          this.error = { ...err, width: "auto" };
          this.loading = false;
        }
      );
  }

  back() {
    if (this.operation === "recover") {
      this._router.navigate(["recover-password/admin-data"]);
    } else {
      this._router.navigate(["create-account/success"]);
    }
  }

  backToLogin() {
    this._router.navigate(['/login'])
  }

  getPhoneX():string{

    let num:string = this._account.getAdminData().phone;
    return "+"+num.substr(0,2)+" "+num.substr(2,2)+"XXXXX"+num.substr(9,10);
  }

  continue() {
    this.error = null;
    this.loading = true;
    this._account.verifyToken(this.form.value.code).subscribe(
      () => this._router.navigate([`${this.operation}-password/new-password`]),
      (err: IErrorAlert) => {
        this.error = { ...err, width: "auto" };
        this.loading = false;
      }
    );
  }

  showSuccessAlert() {
    Swal.fire({
      showClass: {
        popup: "animated fadeIn fast",
      },
      hideClass: {
        popup: "animated fadeOut fast",
      },
      showCloseButton: true,
      html:
        "<img class='logout-icon' src='assets/images/login/logout-icon.png'/>" +
        "<h2 class='title-new-code'>Código de Activación</h2>" +
        "<p class='alert-new-code'>Hemos enviado un nuevo Código de Activación. Tienes 5 minutos para validarlo y seguir con el proceso.</p>",
      confirmButtonText: "Entendido",
      customClass: {
        closeButton: "close-button-class",
        confirmButton: "confirm-button-class",
        title: "title-new-code",
      },
    });
  }

}
